export default __webpack_public_path__ + "static/media/942.4945e21c.gif";